import { Injectable, Inject, LOCALE_ID } from '@angular/core';

import { DecimalPipe } from '@angular/common';
import { DateTimePipe } from '../directives/datetime.pipe';
import { CultureService } from './culture.service';

@Injectable({
    providedIn: 'root',
})
export class GridUtilitiesService {

    private readonly DATE_PIPE = new DateTimePipe(this.locale);
    private readonly DECIMAL_PIPE = new DecimalPipe(this.locale);

    constructor(@Inject(LOCALE_ID) private locale: string,
        private culture: CultureService) { }

    readonly timeFormat: string = this.culture.getShortTimePattern();
    readonly dateFormat: string = this.culture.getShortDatePattern();
    readonly dateTimeFormat: string = this.culture.getShortDateTimePattern();

    /**
     * Formatta una colonna di tipo data.
     * Esempio: Dato un tipo { patient: { birthDate: '...' } }
     *   -> dateFormatter('shortDate', ['patient', 'birthDate'])
     *
     * @param format Il formato da utilizzare (https://angular.io/api/common/DatePipe#pre-defined-format-options).
     * @param field  I(l) campi/o dell'oggetto da utilizzare.
     */
    dateFormatter(field: string);
    dateFormatter(field: string[]);
    dateFormatter(field: string | string[]) {
        const fields = typeof field === 'string'
            ? [field]
            : field;

        return this.makeFormatter(fields, value => this.DATE_PIPE.transform(value, this.dateFormat));
    }

    timeFormatter(field: string);
    timeFormatter(field: string[]);
    timeFormatter(field: string | string[]) {
        const fields = typeof field === 'string'
            ? [field]
            : field;

        return this.makeFormatter(fields, value => this.DATE_PIPE.transform(value, this.timeFormat));
    }

    dateTimeFormatter(field: string);
    dateTimeFormatter(field: string[]);
    dateTimeFormatter(field: string | string[]) {
        const fields = typeof field === 'string'
            ? [field]
            : field;

        return this.makeFormatter(fields, value => this.DATE_PIPE.transform(value, this.dateTimeFormat));
    }


    /**
         * Formatta una colonna di tipo data.
         * Esempio: Dato un tipo { measures: { A1: '...' } }
         *   -> numberFormatter('1.2-2', ['measures', 'A1'])
         *
         * @param format Il formato da utilizzare (https://medium.com/ag-grid/enhance-your-angular-grid-reports-with-formatted-values-and-links-34fa57ca2952).
         * @param field  I(l) campi/o dell'oggetto da utilizzare.
         */
    numberFormatter(format: string, field: string);
    numberFormatter(format: string, field: string[]);
    numberFormatter(format: string, field: string | string[]) {
        const fields = typeof field === 'string'
            ? [field]
            : field;

        return this.makeFormatter(fields, value => this.DECIMAL_PIPE.transform(value, format));
    }

    dateComparator(date1, date2) {
        if (!date1 && !date2)
            return 0;
        if (!date1)
            return -1;
        if (!date2)
            return 1;

        let d1: any = new Date(date1);
        let d2: any = new Date(date2);
        return d1 - d2;
    }

    // C.f. https://github.com/lodash/lodash/blob/4.17.10/lodash.js#L13125
    private makeGetter(fields: string[]) {
        return (obj: any) => {
            let iter = obj;

            for (const field of fields) {
                if (!iter) {
                    return undefined;
                } else {
                    iter = iter[field];
                }
            }

            return iter;
        };
    }

    private makeFormatter(fields: string[], fn: Function) {
        const getter = this.makeGetter(fields);

        return ($event) => {
            const data = !!$event.data ? getter($event.data) : getter($event);

            return fn(data);
        };
    }

    getFullName(person): string {
        let fullName = '';
        if (!!person) {
            if (!!person.fullName) {
                fullName = person.fullName;
            } else {
                if (!!person.lastName) {
                    fullName += person.lastName;
                }
                else if (!!person.surname) {
                    fullName += person.surname;
                }

                if (fullName != "")
                    fullName += ' ';

                if (!!person.firstName) {
                    fullName += person.firstName;
                }
                else if (!!person.name) {
                    fullName += person.name;
                }
            }
        }
        return fullName;
    }
}
